import axios from '@/axios'

export default {
  setScore(evententry, score, tiebreaker, workout, videolink, scaled, notes, scorecardlink) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/leaderboards/set-score/${ evententry._id }`, {
          evententry: evententry,
          score: score,
          tiebreaker: tiebreaker,
          workout: workout,
          videolink: videolink,
          scaled: scaled,
          notes: notes,
          scorecardlink
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data))
    })
  }
}
